import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import { Button, CircularProgress } from "@material-ui/core";
import useStyles from "./styles";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import {
  getUWFormsService,
  printUWFormsService,
  getPrint,
  getPrintStatus,
} from "../../services/policy.service";
import {
  ChevronRight as Expand,
  ExpandMore as Collpase,
} from "@material-ui/icons";
import DateTimeWidget from "../../widgets/DateTimeWidget/DateTimeWidget";
import { formateWithTz } from "../../shared/dateFormat";
import Loader from "../../shared/loader";
import Notify from "../../shared/Notify";
import { NotifyModel } from "../../models/Auth.model";
import { downloadPdfFile } from "../../shared/FileDownload";
function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `45%`,
    left: `50%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const UnderWriting = (props) => {
  const classes = useStyles();
  const { open, modalClose } = props;
  const [sampleDataUWForms, setSampleDataUWFroms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [isSelectedAllForms, setIsSelectedAllForms] = useState(false);
  const [modalStyle] = useState(getModalStyle);
  const [isLoader, setIsLoader] = useState(false);
  var timer;
  const [selectedDate, setSelectedDate] = useState(formateWithTz(new Date()));
  const [notifyProps, setNotifyProps] = useState(NotifyModel);
  useEffect(() => {
    if (open) {
      getUWForms(selectedDate);
    }
  }, [open]);

  const handleExpandCollapse = (form, index) => {
    let sampleDataUWFormsTemp = [...sampleDataUWForms];
    sampleDataUWFormsTemp[index]["isExpanded"] = !form.isExpanded;
    setSampleDataUWFroms(sampleDataUWFormsTemp);
  };

  const handleSelectAll = (forms, type, parentIndex) => {
    let sampleDataUWFormsTemp = [...sampleDataUWForms];
    setIsSelectedAllForms(false);
    sampleDataUWFormsTemp.map((forms, index) => {
      if (parentIndex === index) {
        forms.isSelectedAll = type;
        forms.user.map((row) => {
          row.isSelected = type;
          return row;
        });
      }
      return forms;
    });
    setSampleDataUWFroms(sampleDataUWFormsTemp);
  };

  const handleSingleSelection = (user, type, parentIndex, chlidIndex) => {
    let sampleDataUWFormsTemp = [...sampleDataUWForms];
    let count = 0;
    setIsSelectedAllForms(false);
    sampleDataUWFormsTemp.map((forms, pindex) => {
      if (pindex === parentIndex) {
        forms.user.map((row, cindex) => {
          if (chlidIndex === cindex) {
            row.isSelected = type;
          }
          if (row.isSelected) {
            count = count + 1;
          }
          return row;
        });
        if (forms.user.length === count) {
          forms.isSelectedAll = true;
        } else {
          forms.isSelectedAll = false;
        }
      }
      return forms;
    });
    setSampleDataUWFroms(sampleDataUWFormsTemp);
  };

  const handleSelectionAll = (type) => {
    setIsSelectedAllForms(type);
    let sampleDataUWFormsTemp = [...sampleDataUWForms];
    sampleDataUWFormsTemp.map((forms) => {
      forms.user.map((row) => {
        row.isSelected = type;
        return row;
      });
      forms.isSelectedAll = type;
      return forms;
    });
    setSampleDataUWFroms(sampleDataUWFormsTemp);
  };

  const getUWForms = (date) => {
    setIsLoading(true);
    getUWFormsService(date).then((data) => {
      setIsLoading(false);
      if (data && data.data.statusCode === 200) {
        setIsSelectedAllForms(false);
        data.data.response.map((form) => {
          form.isSelectedAll = false;
          form.isExpanded = true;
          form.user.map((userRow) => {
            userRow.isSelected = false;
            return userRow;
          });
          return form;
        });
        setSampleDataUWFroms(data.data.response);
      }
    });
  };

  const handleOnChange = (body, date) => {
    setSelectedDate(body.value);
    getUWForms(body.value);
  };

  const handlePrint = (e) => {
    e.preventDefault();
    let undFormsToBePrintTemp = [];
    sampleDataUWForms.forEach((element, index) => {
      let formsTemp = [];
      if (element.isSelectedAll) {
        element.user.forEach((user) => {
          formsTemp.push({
            dateRequested: element.dateRequested,
            numReports: user.numReports,
            userName: user.userName,
          });
        });
        undFormsToBePrintTemp.push({
          formDesc: element.formDesc,
          forms: formsTemp,
        });
      } else {
        element.user.forEach((user) => {
          if (user.isSelected) {
            formsTemp.push({
              dateRequested: element.dateRequested,
              numReports: user.numReports,
              userName: user.userName,
            });
            undFormsToBePrintTemp.push({
              formDesc: element.formDesc,
              forms: formsTemp,
            });
          }
        });
      }
    });
    let body = {
      undFormsToBePrint: undFormsToBePrintTemp,
    };
    if (undFormsToBePrintTemp.length === 0) {
      setNotifyProps({
        ...notifyProps,
        message: "Please select Forms to print",
        type: "error",
        toggle: true,
      });
      return true;
    }
    setBtnLoader(true);
    setIsLoader(true);
    printUWFormsService(body)
      .then((data) => {
        setBtnLoader(false);
        if (data.data.statusCode === 200) {
          localStorage.setItem("processId", data.data.response.processId);
          // setProcessId(data.data.response.processId);
          setNotifyProps({
            ...notifyProps,
            message: data.data.message,
            type: "long",
            toggle: true,
          });
          timer = setInterval(() => {
            printStatus();
          }, 10000);
          setTimeout(() => {
            modalClose(false, "Modal");
          }, 1500);
        } else {
          setNotifyProps({
            ...notifyProps,
            message: data.data.message,
            type: "error",
            toggle: true,
          });
        }
      })
      .catch((error) => {
        setBtnLoader(false);

        setNotifyProps({
          ...notifyProps,
          message: "Cannot print this form it is being processed",
          type: "error",
          toggle: true,
        });
      });
  };

  const stopTime = () => {
    clearInterval(timer);
  };
  const printForm = () => {
    setNotifyProps({});
    setIsLoader(true);
    let id = localStorage.getItem("processId");
    getPrint(id)
      .then(
        (data) => {
          setIsLoader(false);
          if (data && data.status === 200) {
            setNotifyProps({
              ...notifyProps,
              toggle: false,
            });
            let content = data.headers["content-disposition"];
            let fileName = content
              .split(";")[1]
              .split("filename")[1]
              .split("=")[1]
              .trim();
            let buffer = data.data;
            downloadPdfFile(buffer, fileName);
            let blob = new Blob([buffer], { type: "application/pdf" });
            let fileURL = window.URL.createObjectURL(blob);
            window.open(fileURL);
          } else {
            setNotifyProps({
              ...notifyProps,
              message: "Cannot print this form it is being processed",
              type: "error",
              toggle: true,
            });
          }
        },
        (error) => {
          setIsLoader(false);
          setNotifyProps({
            ...notifyProps,
            message: "Cannot print this form it is being processed",
            type: "error",
            toggle: true,
          });
        },
      )
      .catch((err) => {
        setNotifyProps({
          ...notifyProps,
          message: "Cannot print this form it is being processed",
          type: "error",
          toggle: true,
        });
      });
  };
  const printStatus = () => {
    let id = localStorage.getItem("processId");
    getPrintStatus(id)
      .then(
        (result) => {
          if (result && result.data.statusCode === 200) {
            if (result.data.response) {
              stopTime();
              printForm();
            }
          } else {
          }
        },
        (error) => {},
      )
      .catch((err) => {
        setNotifyProps({});
        showError();
      });
  };
  function showError() {
    stopTime();
    setIsLoader(false);
    setTimeout(() => {
      setNotifyProps({
        ...notifyProps,
        message: "Something Went Wrong",
        type: "error",
        toggle: true,
      });
    }, 1000);
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={() => modalClose(false, "Modal")}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div style={modalStyle} className={classes.paper500}>
          <div className={`flex-box  ${classes.modalTitle}`}>
            <div id="simple-modal-title">Underwriting Forms</div>
            <div>
              <DateTimeWidget
                id="selectedDate"
                name="selectedDate"
                value={selectedDate}
                onChange={handleOnChange}
                disabled={btnLoader}
              />
            </div>
          </div>

          <div className={classes.modalBody}>
            {isLoading ? (
              <div
                style={{ height: "40vh", overflowY: "auto" }}
                className={"mt-3 text-center"}
              >
                <h6 className="circular-progress">
                  <CircularProgress size={30} />{" "}
                </h6>
              </div>
            ) : (
              <div className={"continaer ml-2 mr-2"}>
                <div className={"row m-0 mt-2"}>
                  <div className={"col-1 pl-0"}>
                    {sampleDataUWForms.length ? (
                      isSelectedAllForms ? (
                        <CheckBoxIcon
                          htmlColor={"#81d4fa"}
                          onClick={() => handleSelectionAll(false)}
                        />
                      ) : (
                        <CheckBoxOutlineBlankIcon
                          htmlColor={"#81d4fa"}
                          onClick={() => handleSelectionAll(true)}
                        />
                      )
                    ) : null}
                  </div>
                  <div className={"col-7 uw-table-label"}>User Name </div>
                  <div className={"col-4 uw-table-label"}>No. of Reports</div>
                </div>
                <div style={{ height: "40vh", overflowY: "auto" }}>
                  {sampleDataUWForms.map((forms, parentIndex) => {
                    return (
                      <ul
                        key={parentIndex}
                        style={{
                          margin: "10px 0px 0px 0px",
                          cursor: "pointer",
                          listStyleType: "none",
                          backgroundColor: forms.isExpanded
                            ? "#eeeeee"
                            : "#fff",
                          padding: "0px",
                        }}
                      >
                        <div className={"flex-box "}>
                          <div>
                            {forms.isSelectedAll ? (
                              <CheckBoxIcon
                                htmlColor={"#81d4fa"}
                                onClick={() =>
                                  handleSelectAll(forms, false, parentIndex)
                                }
                              />
                            ) : (
                              <CheckBoxOutlineBlankIcon
                                htmlColor={"#81d4fa"}
                                onClick={() =>
                                  handleSelectAll(forms, true, parentIndex)
                                }
                              />
                            )}
                          </div>
                          <div
                            style={{
                              width: "95%",
                              fontSize: "12px",
                              padding: "5px",
                            }}
                            onClick={() =>
                              handleExpandCollapse(forms, parentIndex)
                            }
                          >
                            {forms.isExpanded ? (
                              <Collpase htmlColor={"#9e9e9e"} />
                            ) : (
                              <Expand htmlColor={"#9e9e9e"} />
                            )}
                            <span className={"uw-row-data"}>
                              {forms.formDesc}
                            </span>
                          </div>
                        </div>

                        {forms.isExpanded
                          ? forms.user.map((user, chlidIndex) => {
                              return (
                                <li
                                  key={chlidIndex}
                                  className={"pr-2 pl-4"}
                                  style={{ backgroundColor: "#fff" }}
                                >
                                  <div
                                    className={"flex-box"}
                                    style={{ height: "40px" }}
                                  >
                                    <div>
                                      {user.isSelected ? (
                                        <CheckBoxIcon
                                          htmlColor={"#81d4fa"}
                                          onClick={() =>
                                            handleSingleSelection(
                                              user,
                                              false,
                                              parentIndex,
                                              chlidIndex,
                                            )
                                          }
                                        />
                                      ) : (
                                        <CheckBoxOutlineBlankIcon
                                          htmlColor={"#81d4fa"}
                                          onClick={() =>
                                            handleSingleSelection(
                                              user,
                                              true,
                                              parentIndex,
                                              chlidIndex,
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        width: "80%",
                                        marginLeft: "10px",
                                      }}
                                      className={"uw-row-data "}
                                    >
                                      {user.userName}
                                    </div>
                                    <div
                                      style={{
                                        width: "20%",
                                        marginLeft: "10px",
                                      }}
                                      className={"uw-row-data "}
                                    >
                                      {user.numReports}
                                    </div>
                                  </div>
                                </li>
                              );
                            })
                          : null}
                        <hr className={"mt-0"} />
                      </ul>
                    );
                  })}
                </div>
              </div>
            )}
            <div className={classes.modalFooter}>
              <Button
                variant="outlined"
                className={classes.cancelButton}
                type="button"
                disabled={btnLoader}
                onClick={() => modalClose(false, "Modal")}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className={classes.deActivateButton}
                type="button"
                disabled={btnLoader}
                onClick={handlePrint}
              >
                {btnLoader ? "Printing" : "Print"}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Notify notifyProps={notifyProps} />
      <Loader open={isLoader} />
    </div>
  );
};
export default UnderWriting;
